export const countries = [
  {
    name: 'Zambia',
    code: 'ZM',
    phoneCode: '+260',
    provinces: ['Central', 'Copperbelt', 'Eastern', 'Luapula', 'Lusaka', 'Muchinga', 'Northern', 'North-Western', 'Southern', 'Western']
  },
  {
    name: 'South Africa',
    code: 'ZA',
    phoneCode: '+27',
    provinces: ['Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga', 'Northern Cape', 'North West', 'Western Cape']
  },
  {
    name: 'Kenya',
    code: 'KE',
    phoneCode: '+254',
    provinces: ['Nairobi', 'Central', 'Coast', 'Eastern', 'North Eastern', 'Nyanza', 'Rift Valley', 'Western']
  },
  {
    name: 'Nigeria',
    code: 'NG',
    phoneCode: '+234',
    provinces: ['Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'FCT', 'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara']
  },
  {
    name: 'Ghana',
    code: 'GH',
    phoneCode: '+233',
    provinces: ['Ashanti', 'Brong-Ahafo', 'Central', 'Eastern', 'Greater Accra', 'Northern', 'Upper East', 'Upper West', 'Volta', 'Western']
  },
  {
    name: 'Tanzania',
    code: 'TZ',
    phoneCode: '+255',
    provinces: ['Arusha', 'Dar es Salaam', 'Dodoma', 'Geita', 'Iringa', 'Kagera', 'Katavi', 'Kigoma', 'Kilimanjaro', 'Lindi', 'Manyara', 'Mara', 'Mbeya', 'Morogoro', 'Mtwara', 'Mwanza', 'Njombe', 'Pemba North', 'Pemba South', 'Pwani', 'Rukwa', 'Ruvuma', 'Shinyanga', 'Simiyu', 'Singida', 'Songwe', 'Tabora', 'Tanga', 'Unguja North', 'Unguja South']
  },
  {
    name: 'Uganda',
    code: 'UG',
    phoneCode: '+256',
    provinces: ['Central', 'Eastern', 'Northern', 'Western']
  },
  {
    name: 'Rwanda',
    code: 'RW',
    phoneCode: '+250',
    provinces: ['Eastern', 'Kigali', 'Northern', 'Southern', 'Western']
  },
  {
    name: 'Botswana',
    code: 'BW',
    phoneCode: '+267',
    provinces: ['Central', 'Ghanzi', 'Kgalagadi', 'Kgatleng', 'Kweneng', 'North East', 'North West', 'South East', 'Southern']
  },
  {
    name: 'Malawi',
    code: 'MW',
    phoneCode: '+265',
    provinces: ['Central', 'Northern', 'Southern']
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    phoneCode: '+263',
    provinces: ['Bulawayo', 'Harare', 'Manicaland', 'Mashonaland Central', 'Mashonaland East', 'Mashonaland West', 'Masvingo', 'Matabeleland North', 'Matabeleland South', 'Midlands']
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    phoneCode: '+44',
    provinces: ['England', 'Scotland', 'Wales', 'Northern Ireland']
  },
  {
    name: 'United States',
    code: 'US',
    phoneCode: '+1',
    provinces: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']
  }
];

export const sectors = [
  'Agriculture & Food Processing',
  'Mining & Minerals',
  'Manufacturing',
  'Construction & Real Estate',
  'Information Technology',
  'Financial Services',
  'Healthcare & Pharmaceuticals',
  'Education & Training',
  'Tourism & Hospitality',
  'Transportation & Logistics',
  'Energy & Utilities',
  'Telecommunications',
  'Retail & Wholesale Trade',
  'Professional Services',
  'Media & Entertainment',
  'Environmental Services',
  'Textiles & Clothing',
  'Automotive',
  'Aviation',
  'Maritime',
  'Security Services',
  'Legal Services',
  'Consulting',
  'Marketing & Advertising',
  'Human Resources',
  'Accounting & Auditing',
  'Engineering',
  'Architecture',
  'Research & Development',
  'Non-Profit & NGO'
];

export const currencies = [
  { code: 'ZMW', name: 'Zambian Kwacha', symbol: 'K' },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' }
];